import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  return (
    <main className="not-found">
      <div className="not-found__container">
        <h1 className="not-found__title">404</h1>
        <h2 className="not-found__subtitle">Seite nicht gefunden</h2>
        <p className="not-found__text">
          Die angeforderte Seite existiert leider nicht. Möglicherweise wurde sie verschoben oder gelöscht.
        </p>
        <Link to="/" className="not-found__link" title="Zurück zur Startseite – StyroR Styropor Recycling">
          Zurück zur Startseite
        </Link>
      </div>
    </main>
  );
};

export default NotFound;
